function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M62,40H53.4V4.81h-25V40H19.77l-11,21H73.05ZM30.38,6.81h21V13H42.82v2H51.4v7.5H48.58v2H51.4V32H42.82v2H51.4V40h-21ZM21,42H60.79l8.95,17H12Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.16 52.6 32.61 52.6 32.61 48.31 45.59 48.31 45.59 46.31 30.61 46.31 30.61 54.6 51.16 54.6 51.16 49.31 49.16 49.31 49.16 52.6",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.82,
    y: 22.54,
    width: 3.82,
    height: 2,
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.65,71.42a3.22,3.22,0,0,1-.7-2.74,3.52,3.52,0,0,1,1.53-2.56L31,65.25l-.48-.88a5.51,5.51,0,0,0-2.54,4,5.2,5.2,0,0,0,1.32,4.5h0A3.2,3.2,0,0,1,30,75.63a3.56,3.56,0,0,1-1.52,2.57l1,1.75a5.54,5.54,0,0,0,2.54-4A5.16,5.16,0,0,0,30.65,71.42Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.29,71.43h0a3.21,3.21,0,0,1-.71-2.75,3.56,3.56,0,0,1,1.53-2.56l-.49-.87-.48-.88a5.54,5.54,0,0,0-2.54,4,5.2,5.2,0,0,0,1.32,4.5h0a3.2,3.2,0,0,1,.71,2.74,3.56,3.56,0,0,1-1.52,2.57l1,1.75a5.51,5.51,0,0,0,2.54-4A5.14,5.14,0,0,0,54.29,71.43Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.46,71.42a3.2,3.2,0,0,1-.69-2.74,3.53,3.53,0,0,1,1.52-2.56l-.49-.87-.47-.88a5.48,5.48,0,0,0-2.54,4,5.17,5.17,0,0,0,1.32,4.5h0a3.2,3.2,0,0,1,.71,2.74,3.59,3.59,0,0,1-1.53,2.57l1,1.75a5.57,5.57,0,0,0,2.54-4A5.11,5.11,0,0,0,42.46,71.42Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPau);
export default __webpack_public_path__ + "static/media/pau.78ee7d8246d5a5b8c79dd1443d6b2db7.svg";
export { ForwardRef as ReactComponent };